import React from "react";
import { NotificationManager } from "react-notifications";
import { Formik } from "formik";

import FormTextInput from "../../../../../base/form-text-input";
import { IdVerificationDomain } from "../domain";
import AppModal, {
  PRIMARY_ACTION_VARIANTS,
} from "../../../../modals/app-modal";

const IdVerificationRejectionModal = ({
  showModal,
  setShowIdVerificationRejectionModal = () => {},
  setShowIdVerificationModal = () => {},
  refreshUserDetails = () => {},
  requestId,
}) => {
  const onSubmitForm = (values = {}) => {
    try {
      IdVerificationDomain.handleRejectionIdVerification({
        requestId,
        reason: values?.reason,
        setShowIdVerificationRejectionModal,
        setShowIdVerificationModal,
        refreshUserDetails,
      });
    } catch (error) {
      NotificationManager.error("Unknown error occurred");
      console.log(error);
    }
  };

  const handleCloseModal = () => {
    setShowIdVerificationRejectionModal(false);
  };

  return (
    <Formik initialValues={{ reason: null }} onSubmit={onSubmitForm}>
      {({ handleChange, values, handleSubmit, isSubmitting }) => (
        <AppModal
          visibility={showModal}
          actionType={PRIMARY_ACTION_VARIANTS.WARNING}
          title="Reject?"
          description="Do you want to reject this NIC?"
          primaryLabel="Reject"
          secondaryLabel="Cancel"
          loading={isSubmitting}
          onSecondaryAction={handleCloseModal}
          handleClose={handleCloseModal}
          onPrimaryAction={handleSubmit}
        >
          <FormTextInput
            label="Reason"
            multiline
            placeholder="Optional"
            name="reason"
            onChangeInput={handleChange}
          />
        </AppModal>
      )}
    </Formik>
  );
};

export default IdVerificationRejectionModal;
